import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Card, CardBody, CardHeader } from "reactstrap";
import { usePagination } from "../../hooks/usePagination";
import { format } from "date-fns";
import { useEffect, useState } from "react";
import ApiService from "../../services/apiService";
import { method } from "lodash";

type chartProp = {
fromDateTime?: string | null;
toDateTime?: string | null;
generateKey?: number | null | undefined;
};


const PieCharts = ({fromDateTime,toDateTime,generateKey}:chartProp) => {
    
   const [active,setActive] = useState<boolean>(false)
   const [oneActive,setOneActive] = useState<boolean>(false)
   const [isEnabled,setIsEnabled] = useState<boolean>(false)
   const [fromDate,setFromDate] = useState<any>()
   const [toDate,setToDate] = useState<any>()
   const [alarmsCount,setAlarmsCount] = useState<any[]>()
    
   const endDate = new Date();
   const startDate = new Date();
   startDate.setDate(startDate.getDate() - 7); 
   startDate.setHours(0, 0, 0, 0);
   
    useEffect(()=>{
      const getAlarmCount = async() =>{
        try{
           const response = await ApiService.axiosApi(`/alarms/alarmcount`,{
              method:'GET',
              params:{
                 fromDate:fromDate ? fromDate:format(startDate, 'yyyy-MM-dd HH:mm:ss'),
                 toDate:toDate ? toDate  : format(endDate, 'yyyy-MM-dd HH:mm:ss')
              }
           })
           if(response.success){
              setAlarmsCount(response.data)
           }else{
             console.log(response.status || 'Unable To Get Alarms Count')
           }
        }catch(error){
           console.log(error);
        }
     }

     getAlarmCount();
    },[fromDate,toDate])
    
    

   



    const setSixMonth = () =>{
      const endDate = new Date(); // current date-time
     const startDate = new Date();
     startDate.setMonth(startDate.getMonth() - 6); // subtract 6 months
      const from = format(startDate,'yyyy-MM-dd HH:mm:ss')
      const to = format(endDate,'yyyy-MM-dd HH:mm:ss')

      setFromDate(from);
      setToDate(to);

    }

    const setOneYear = () =>{
      const endDate = new Date(); // current date-time
      const startDate = new Date();
      startDate.setFullYear(startDate.getFullYear() - 1); // subtract 1 year
      
      const from = format(startDate,'yyyy-MM-dd HH:mm:ss')
      const to = format(endDate,'yyyy-MM-dd HH:mm:ss')
      
      
      setFromDate(from);
      setToDate(to)
      
       
    }
     

   console.log(alarmsCount)
     
    if(active){
      console.log(active)
    }
    
  

  const COLORS = ["#DC3545", "rgb(43, 95, 96)", "#9470CE", "#EFCF20"];

  return (
    <Card className="m-0 b-r-0">
      <CardHeader>

         <div className="d-flex justify-content-between">
         <div className="d-flex flex-column">
              <h5 style={{ fontWeight: "600" }}>Alarms Percentage</h5>
              <h6 style={{fontSize:'12px'}}> {fromDateTime ? format(new Date(fromDateTime), "dd/MM/yyyy ") : format(startDate,"dd/MM/yyyy ")} -
              {toDateTime ? format(new Date(toDateTime), "dd/MM/yyyy ") : format(endDate,"dd/MM/yyyy ")}</h6>  
           </div>
         </div>
        
      </CardHeader>
      <CardBody >
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={alarmsCount}
              dataKey="percentage"
              nameKey="alarm"
              cx="50%"
              cy="50%"
              outerRadius={80}
              fill="#8884d8"
              label
            >
              {alarmsCount?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip 
             />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </CardBody>
    </Card>
  );
};

export default PieCharts;
